import { PriceBookItemQueryResponse } from '@/api/types/priceBookTypes'
import moment from 'moment'

export default class PriceBookItem {
  id: string
  name: string
  type: string
  defaultRate: number | null
  description: string | null
  unitOfMeasure: string | null
  associatedHubId: string | null
  associatedResourceTypeIds: number[]
  pickupLocationIds: number[]
  destinationLocationIds: number[]
  pickupLocationTagIds: number[]
  destinationLocationTagIds: number[]
  validFrom: Date | null
  validUntil: Date | null
  constructor(json: PriceBookItemQueryResponse) {
    this.id = json.id
    this.name = json.name
    this.type = json.type
    this.defaultRate = json.default_rate
    this.description = json.description
    this.unitOfMeasure = json.unit_of_measure
    this.associatedHubId = json.associated_hub_id
    this.associatedResourceTypeIds = json.associated_resource_type_ids
    this.pickupLocationIds = json.pickup_location_ids
    this.destinationLocationIds = json.destination_location_ids
    this.pickupLocationTagIds = json.pickup_location_tag_ids
    this.destinationLocationTagIds = json.destination_location_tag_ids
    this.validFrom =
      json.valid_from === null ? null : moment(json.valid_from).toDate()
    this.validUntil =
      json.valid_until === null ? null : moment(json.valid_until).toDate()
  }
}
